import { Action } from '@/_core/fluxstore/types';
import { NotificationsState, UserNotificationModel, UserNotificationReply } from '../types';
import { useNotificationsStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { snackbar } from '@/_core/app-components/use';
import { AddBoardCommentCommand, CardCommentModel, BoardCommentModel } from '@/api/notifications/commands';
import { AddCardCommentCommand } from '@/api/common';

const { registerMiddleware, registerReducer } = useNotificationsStore();

export class ReplyNotification extends Action<NotificationsState> {
    public static ACTION_TYPE = 'ReplyNotification';
    public constructor(public notification: UserNotificationModel, public replyText: string) {
        super(ReplyNotification.ACTION_TYPE);
    }
}

const middleware = async (state: NotificationsState, action: ReplyNotification): Promise<boolean> => {
    let newComment;
    let command: AddCardCommentCommand | AddBoardCommentCommand;
    if (action.notification.relatedCardId != null) {
        newComment = await CardCommentModel.createReplyFromNotification(action.notification, action.replyText);
        command = await AddCardCommentCommand.create(
            action.notification.relatedCardId,
            action.notification.relatedCardName,
            newComment,
            action.notification.sourceUserId,
            [action.notification.sourceUserId],
            action.notification.storymapId,
            action.notification.storymapSlug,
            action.notification.workspaceId
        );
    } else {
        newComment = await BoardCommentModel.createReplyFromNotification(action.notification, action.replyText);
        command = await AddBoardCommentCommand.create(
            newComment,
            action.notification.sourceUserId,
            [action.notification.sourceUserId],
            action.notification.storymapId,
            action.notification.storymapSlug,
            action.notification.workspaceId
        );
    }

    return await useSendCommand(action, {
        createCommand: () => command,
        onSuccess: () => {
            snackbar.showSuccess('Your reply has been sent!');
        },
    });
};

const reducer = (state: NotificationsState, action: ReplyNotification): void => {
    const notification = state.allNotifications.find((notification) => notification.id === action.notification.id);

    notification.replies.push(new UserNotificationReply(action.replyText, new Date()));
};

//@ts-ignore
registerMiddleware(ReplyNotification.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ReplyNotification.ACTION_TYPE, reducer);
